import { api } from './api';
import { FILTER_CONSTANTS } from './constants';
import { getStatusForApi } from './statusHelpers';
import { NEWS_STATUS_CHANGE_EVENT } from '../components/Sidebar/AdminSidebar';

/**
 * Вспомогательная функция для обновления только URL, сохраняя текущий статус активности
 */
const updateNewsSourceUrl = async (newsId, sourceUrl, currentIsActive) => {
    try {
        // Сначала получаем текущие данные новости, если статус активности не передан
        let isActive = currentIsActive;
        
        if (isActive === undefined) {
            const response = await api.get(`/admin/news/${newsId}`);
            if (response.data && response.data.isActive !== undefined) {
                isActive = response.data.isActive;
            }
        }
        
        // Обновляем URL, сохраняя текущий статус активности
        return await api.put(`/admin/news/${newsId}`, { 
            sourceUrl,
            isActive  // Явно указываем текущий статус активности
        });
    } catch (error) {
        console.error('Error updating source URL:', error);
        throw error;
    }
};

export const executeBulkAction = async ({
    action,
    selectedIds,
    updateAllNews,
    updateStats,
    fetchNewsData,
    clearSelection,
    onError,
    newsItems = []  // Добавляем параметр для информации о новостях
}) => {
    try {
        switch (action) {
            case FILTER_CONSTANTS.BULK_ACTIONS.ACTIVATE:
            case FILTER_CONSTANTS.BULK_ACTIONS.DEACTIVATE:
                const isActive = action === FILTER_CONSTANTS.BULK_ACTIONS.ACTIVATE;
                await Promise.all(selectedIds.map(id => 
                    api.put(`/admin/news/${id}/status`, { isActive })
                ));
                updateAllNews(prevNews => 
                    prevNews.map(item => 
                        selectedIds.includes(item._id) 
                            ? { ...item, isActive } 
                            : item
                    )
                );
                
                // Генерируем событие для обновления статистики в сайдбаре
                window.dispatchEvent(new CustomEvent(NEWS_STATUS_CHANGE_EVENT, {
                    detail: { 
                        bulkUpdate: true,
                        count: selectedIds.length,
                        isActive
                    }
                }));
                break;

            case 'delete':
                if (window.confirm('Вы уверены, что хотите удалить выбранные новости?')) {
                    await Promise.all(selectedIds.map(id => api.delete(`/admin/news/${id}`)));
                    updateAllNews(prevNews => 
                        prevNews.filter(item => !selectedIds.includes(item._id))
                    );
                    
                    // При удалении также обновляем статистику
                    window.dispatchEvent(new CustomEvent(NEWS_STATUS_CHANGE_EVENT));
                }
                break;

            case 'changeUrl':
                const newUrl = prompt('Введите новый URL:');
                if (newUrl) {
                    // Находим текущие статусы активности для каждой новости
                    const newsMap = {};
                    newsItems.forEach(item => {
                        if (selectedIds.includes(item._id)) {
                            newsMap[item._id] = item.isActive;
                        }
                    });
                    
                    await Promise.all(selectedIds.map(id => 
                        updateNewsSourceUrl(id, newUrl, newsMap[id])
                    ));
                }
                break;
                
            case FILTER_CONSTANTS.BULK_ACTIONS.CHANGE_DOMAIN:
                const oldText = prompt('Введите текст для поиска в URL (например, домен или часть пути):');
                if (!oldText) break;
                
                const newText = prompt('Введите текст для замены:');
                if (!newText) break;
                
                // Получаем данные новостей для выбранных ID
                const newsToUpdate = newsItems.filter(item => selectedIds.includes(item._id));
                
                // Массив для хранения обновленных URL для каждой новости
                const updatedNewsUrls = {};
                
                // Обновляем URL каждой новости, заменяя указанную часть
                await Promise.all(newsToUpdate.map(news => {
                    // Проверяем, содержит ли текущий URL указанный текст
                    if (news.sourceUrl && news.sourceUrl.includes(oldText)) {
                        // Заменяем текст в URL
                        const newSourceUrl = news.sourceUrl.replace(new RegExp(oldText, 'g'), newText);
                        updatedNewsUrls[news._id] = newSourceUrl;
                        
                        // Используем специальную функцию для обновления URL, передавая текущий статус активности
                        return updateNewsSourceUrl(news._id, newSourceUrl, news.isActive);
                    }
                    return Promise.resolve(); // Пропускаем новости без совпадения текста
                }));
                
                // Обновляем локальное состояние
                updateAllNews(prevNews => 
                    prevNews.map(item => 
                        updatedNewsUrls[item._id] 
                            ? { ...item, sourceUrl: updatedNewsUrls[item._id] } 
                            : item
                    )
                );
                
                break;
        }

        await fetchNewsData();
        clearSelection();
    } catch (err) {
        console.error('Error performing bulk action:', err);
        onError('Ошибка при выполнении массового действия');
    }
}; 